<template>
  <div id="app" class="container-fluid">
    <notifications group="app" position="top center"/>
    <div class="row h-100 login-container"  v-if="!isUserLoggedIn">
      <Login></Login>
    </div>
    <div class="row nav-left" v-else>
      <aside class="main-sidebar col-12 col-md-3 col-lg-2 px-0">
        <Navbar @onLoggedOut="onLoggedOut" @onRouteClicked="onRouteClicked"></Navbar>
      </aside>
      <main class="main-content p-0 col-sm-12 col-md-9 col-lg-10">
        <Header></Header>
        <div class="main-content-container px-4 pb-4 container-fluid">
          <router-view :key="viewKey"></router-view>
        </div>
        <Footer></Footer>
      </main>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import Header from './components/common/Header'
  import Footer from './components/common/Footer.vue'
  import Navbar from './components/common/Navbar.vue'
  import Login from './views/common/Login.vue'
  import * as messaging from './helpers/messaging'
  Vue.prototype.$messaging = messaging;
  import * as appSettingCodes from './helpers/appSettingCodes'
  Vue.prototype.$appSettingCodes = appSettingCodes;
  Vue.prototype.$isLoginForm = false;
  Vue.prototype.$currency = 'RON';
  Vue.prototype.$prevRoute = null;
  import BootstrapVue from 'bootstrap-vue'
  import 'bootstrap-vue/dist/bootstrap-vue.css'
  Vue.use(BootstrapVue)
  import Vue from 'vue'
  import Vuetify from 'vuetify'
  Vue.use(Vuetify);

  export default{
    name: 'App',
    data(){
      return{
        viewKey: 0,

      }
    },
    components: {
      Header,
      Footer,
      Navbar,
      Login
    },
    computed:{
      ...mapGetters([
        'appSettings',
        'user',
      ]),
      isUserLoggedIn: {
        get: function() {
          return this.user && this.user.id > 0;
        },
        set: function(newVal) {
          return newVal;
        }

      },
    },
    methods: {
      ...mapActions([
        'getAppSettings',
      ]),
      onLoggedOut() {

      },
      onRouteClicked() {
        if(this.$route.name === 'postDetails') {
          this.$router.push('/posts', () => {
            this.$router.push('/posts/add');
          });
        } else {
          this.viewKey++;
        }
      }
    },
    created(){

    },
    mounted(){
      this.getAppSettings();
    },
    watch: {
      user: function(newVal) {
        this.isUserLoggedIn = newVal;
      }
    }
  }
</script>

<style>
  #app{
    height: 100%;
    min-height: 100%;
  }
  .nav-left {
    position: sticky;
  }

  .main-sidebar {
    top: 0;
    position: sticky !important;
    height: 100vh;
    background: #fff;
    z-index: 1070;
    will-change: transform;
    -webkit-transition: -webkit-transform .2s ease-in-out;
    transition: -webkit-transform .2s ease-in-out;
    transition: transform .2s ease-in-out;
    transition: transform .2s ease-in-out,-webkit-transform .2s ease-in-out;
    -webkit-box-shadow: 0 0.125rem 9.375rem rgba(90,97,105,.1), 0 0.25rem 0.5rem rgba(90,97,105,.12), 0 0.9375rem 1.375rem rgba(90,97,105,.1), 0 0.4375rem 2.1875rem rgba(165,182,201,.1);
    box-shadow: 0 0.125rem 9.375rem rgba(90,97,105,.1), 0 0.25rem 0.5rem rgba(90,97,105,.12), 0 0.9375rem 1.375rem rgba(90,97,105,.1), 0 0.4375rem 2.1875rem rgba(165,182,201,.1);
  }
  .pl-0, .px-0 {
    padding-left: 0!important;
  }
  .pr-0, .px-0 {
    padding-right: 0!important;
  }

  header{

  }
  footer{

  }
  .main-content-container{
    height: calc(100% - 90px);
    min-height: calc(100% - 90px);
    background-color: #f2f3f5;
    padding: 25px;
    overflow: hidden;
  }
  .main-content{
    z-index: 1070;
  }
  .h-100{
    height: 100%;
    min-height: 100%;
  }
  .login-container{
    background-color: #f2f3f5;
  }

  @media (max-width: 767px) {
    .main-content{
      margin-top: 62px;
    }
    #notifications{
      display: none;
    }
  }

</style>
